import { render, staticRenderFns } from "./StallProductDetail.vue?vue&type=template&id=c6847cee&scoped=true"
import script from "./StallProductDetail.vue?vue&type=script&lang=js"
export * from "./StallProductDetail.vue?vue&type=script&lang=js"
import style0 from "./StallProductDetail.vue?vue&type=style&index=0&id=c6847cee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6847cee",
  null
  
)

export default component.exports